import { DateTime } from 'luxon';
import React from 'react';
import DatePicker from 'react-datetime';
import { withTranslation, WithTranslation } from 'react-i18next';
import Order from '../../../../Model/models/orderModel';
import PaymentType from '../../../../Model/models/paymentTypeModel';
import { OrderFormUtils } from '../../../../utils/orderFormUtils';
// import ProductType from '../../../Model/productType';


interface OrderFormHeaderProps extends WithTranslation {
  order: Order,
  paymentTypes: PaymentType[],
  currencySymbol: string,
  orderUpdated: (order: Order) => void,
  onCurrencyChange: (currency: 'EUR' | 'USD') => void
}

class OrderFormHeader extends React.Component<OrderFormHeaderProps, {}> {

  render() {
    const { order } = this.props;
    const total = order.total;
    const orderAmount = OrderFormUtils.getPriceFormat(total, this.props.currencySymbol);

    return <>
            <div>
                <button className="addButton float-left" style={{
                  marginTop: '0.5em',
                  marginBottom: '1em'
                }} onClick={() => window.history.back()}>
                    {this.props.t('BACK')}
                </button>
            </div>
            <div className='topHead mx-auto d-flex flex-column justify-content-center'>

                <div className='headerContainer m-auto'>
                    <table>
                        <tbody style={{ background: 'transparent' }}>
                            <tr>
                                <td>
                                    <div className='mr-4'>
                                        {this.props.t('ORDER_DETAILS')}:<br />
                                        <input type="text" className="form-control"
                                            required
                                            defaultValue={order.order_id}
                                            disabled={order.source === 'B2B'}
                                            onKeyUp={(e: any) => {
                                              order.order_id = e.target.value.trim() || undefined;
                                              this.props.orderUpdated(order);
                                            }}
                                        />
                                    </div>
                                </td>
                                <td>
                                    <div className='mr-4'>
                                        {this.props.t('ORDER_CODE')}:<br />
                                        <input type="text" className="form-control"
                                            required
                                            defaultValue={order.order_code}
                                            disabled={order.source === 'B2B'}
                                            onKeyUp={(e: any) => {
                                              order.order_code = e.target.value || undefined;
                                              this.props.orderUpdated(order);
                                            }}
                                        />
                                    </div>
                                </td>
                                <td>
                                    <div className='mr-4' style={{ marginLeft: 0 }}>
                                        {this.props.t('SOURCE')}:<br />
                                        <span className='font-weight-bold'>
                                            <select
                                                required
                                                className="form-control"
                                                style={{ width: 200 }}
                                                value={order?.source}
                                                onChange={(e: any) => {
                                                  order.source = e.target.value || undefined;
                                                  if (order.source?.includes('planetwatch.io')) {
                                                    order.currency = 'EUR';
                                                  }
                                                  if (order.source?.includes('planetwatch.us')) {
                                                    order.currency = 'USD';
                                                  }
                                                  if (order.source === 'B2B') {
                                                    const code = DateTime.now().toFormat('yyyy-LL-dd-HH-mm');
                                                    order.order_code = order.order_code || `B2B-${code}`;
                                                    order.order_id = order.order_id || `B2B-${code}`;
                                                  }
                                                  if (order.currency) {
                                                    this.props.onCurrencyChange(order.currency);
                                                  }
                                                  this.props.orderUpdated(order);
                                                }}>
                                                <option>-</option>
                                                <option value='https://planetwatch.io/'>planetwatch.io</option>
                                                <option value='https://planetwatch.us/'>planetwatch.us</option>
                                                <option value='B2B'>B2B</option>
                                            </select>
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    {/* <div className='mr-4'>
                                        {this.props.t('PAYMENT_METHOD')}:<br />
                                        <span className='font-weight-bold align-self-center'>
                                            <select
                                                required
                                                className="form-control"
                                                style={{ width: 200 }}
                                                onChange={(e) => {
                                                  const paymentTypeId = parseInt(e.target.value);
                                                  const paymentType = paymentTypes.find(pt => pt.id === paymentTypeId);
                                                  if (paymentType) {
                                                    order.payment_type = paymentType.id;
                                                    this.props.onPaymentTypeChange(paymentType);
                                                    this.props.orderUpdated(order);
                                                  } else {
                                                    order.payment_type = undefined;
                                                  }
                                                }}>
                                                <option>-</option>
                                                {paymentTypes.map((pt: PaymentType) => <option
                                                    key={pt.id}
                                                    value={pt.id}
                                                    selected={order.payment_type === pt.id}
                                                >
                                                    {pt.type} - {pt.currency}
                                                </option>)}
                                            </select>
                                        </span>
                                    </div> */}
                                    <div className='mr-4'>
                                        {this.props.t('CURRENCY')}:<br />
                                        <span className='font-weight-bold align-self-center'>
                                            <select
                                                required
                                                className="form-control"
                                                style={{ width: 200 }}
                                                value={order.currency}
                                                disabled={order.source !== undefined && order.source !== 'B2B'}
                                                onChange={(e) => {
                                                  const currency = e.target.value as ('USD' | 'EUR');
                                                  if (e.target.value) {
                                                    this.props.onCurrencyChange(currency);
                                                    order.currency = currency;
                                                    this.props.orderUpdated(order);
                                                  } else {
                                                    order.currency = undefined;
                                                  }
                                                }}>
                                                <option>-</option>
                                                <option value={'EUR'}>EUR</option>
                                                <option value={'USD'}>USD</option>
                                            </select>
                                        </span>
                                    </div>
                                </td>
                                <td>
                                    <div className='mr-4 datetime-input' style={{ marginLeft: 0 }} >
                                        {this.props.t('ORDER_DATE')}:<br />
                                        <DatePicker
                                            inputProps={{ readOnly: true }}
                                            value={new Date(order.date as Date)}
                                            timeConstraints={{ hours: { step: 1, min: 0, max: 23 } }}
                                            dateFormat={this.props.t('DATE_FORMAT').toString()}
                                            timeFormat={'HH:mm'}
                                            onChange={(date) => {
                                              try {
                                                order.date = (date as moment.Moment).toDate();
                                                this.props.orderUpdated(order);
                                                this.setState({ order });
                                              } catch (error) {
                                                console.log(error);
                                              }
                                            }} />
                                    </div>
                                </td>
                                <td>
                                    <div style={{ fontSize: '1.5em' }}>
                                        {this.props.t('ORDER_TOTAL')}:<br />
                                        <span className='font-weight-bold'> {orderAmount}</span>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div >
        </>;
  }

}

export default withTranslation()(OrderFormHeader);